import React from "react";

export const overviewFaq = [
  {
    title: "Earn Weekly ETH, Bitcoin, or USD with ETH Staking",
    description: (
      <p className="ml-8">
        Bitcoin is often seen as a long-term growth asset, while staked ETH
        generates weekly income. Our{" "}
        <strong>Bnk To The Future ETH Staking Solution</strong> simplifies
        staking, allowing you to earn rewards without technical expertise.
      </p>
    ),
  },
  {
    title: "Why Stake with Bnk To The Future?",
    description: (
      <p className="ml-8">
        <strong>Weekly Income</strong> — Earn ETH every Monday, with the option
        to withdraw, compound, or convert to Bitcoin, Stablecoins, or fiat.{" "}
        <br />
        <strong>No 32 ETH Requirement</strong> — Stake with any amount—no need
        to run your own validator.
        <br />
        <strong>Flexible Unstaking & Fee Reduction</strong> — Choose between
        unstaking anytime or reducing fees with a <strong>timelock</strong>.
        <br />
        <strong>Security & Compliance</strong> — As a regulated virtual asset
        service provider, we offer a legally compliant staking solution.
      </p>
    ),
  },
  {
    title: "Timelock Staking — Lower Fees & Unlock More Benefits",
    description: (
      <p className="ml-8">
        <strong>No Timelock:</strong> Unstake anytime with a{" "}
        <strong>20% fee on rewards</strong>. <br />
        <strong>Timelock Option:</strong> Fee{" "}
        <strong>reduces by 1% per year</strong>, down to{" "}
        <strong>15% for 5-year timelocks</strong>. <br />
        <strong>Exclusive Bonus:</strong> Timelocking for{" "}
        <strong>at least 1 year with $5,000+</strong> invested{" "}
        <strong>unlocks the Bitcoin Wealth Builder Programme</strong>.
      </p>
    ),
  },
  {
    title: "How It Works",
    description: (
      <>
        <ol>
          <li>
            <strong>Stake ETH</strong> — Lock up your ETH securely.
          </li>
          <li>
            <strong>Earn Weekly Rewards</strong> — Receive staking income every
            Monday.
          </li>
          <li>
            <strong>Flexible Payouts</strong> — Restake, withdraw, or convert
            your earnings.
          </li>
          <li>
            <strong>Choose Timelock or No Timelock</strong> — Maximise
            flexibility or reduce fees.
          </li>
        </ol>
        <p className="ml-8">
          Start staking today and earn passive income while holding ETH!
        </p>
        <a
          className="underline mt-8 ml-8"
          href="https://app.bnktothefuture.com/terms_and_conditions/staking"
        >
          View Full Staking Terms & Fees
        </a>
      </>
    ),
  },
];

export const faq = [
  {
    title: "Is there a minimum investment for ETH staking?",
    description: (
      <p className="ml-8">
        No, you can stake with any amount. However, if you invest{" "}
        <strong>$5,000+</strong> and choose a{" "}
        <strong>minimum 1-year timelock</strong>, you gain access to the{" "}
        <strong>Bitcoin Wealth Builder Program</strong>.
      </p>
    ),
  },
  {
    title: "What is ETH staking?",
    description: (
      <p className="ml-8">
        ETH staking involves locking ETH to help secure the Ethereum network and
        earn rewards. It replaces mining with Proof-of-Stake (PoS).
      </p>
    ),
  },
  {
    title: "What rewards can I earn?",
    description: (
      <p className="ml-8">
        Staking rewards come from new ETH issuance and transaction fees. Returns
        vary based on network activity and the number of validators.
      </p>
    ),
  },
  {
    title: "What fees does BF charge for staking?",
    description: (
      <p className="ml-8">
        <strong>20% fee</strong> on staking rewards for{" "}
        <strong>no timelock staking</strong>. <br />
        Fee <strong> reduces by 1% per year of timelock</strong>, down to{" "}
        <strong>15% for 5-year timelocks</strong>. <br />
        Fees are shared with our staking partner, Figment.
      </p>
    ),
  },
  {
    title: "How long does unstaking take?",
    description: (
      <p className="ml-8">
        <strong>No Timelock:</strong> You can request to unstake at any time.{" "}
        <br />
        <strong>Timelock Staking:</strong> Your ETH remains locked for the
        duration you choose. <br />
        Unstaking times depend on the Ethereum network and may take a few weeks.
        <br />
        <br />
        <a
          className="underline"
          href="https://app.bnktothefuture.com/terms_and_conditions/staking"
        >
          View Full Staking Terms & Conditions
        </a>
      </p>
    ),
  },
];
